import React, { useState, useEffect, useRef } from 'react';
import { dateColTemplate, dowColTemplate, formatCurrency, viewCurrencyTemplate, copyCurrencyTemplate } from './groupIQHelper';
import {
    Popover
} from '@mui/material/';
import moment from 'moment';
import { Grid } from 'smart-webcomponents-react/grid';

import 'smart-webcomponents-react/source/styles/smart.default.css';
import NotesPopup from '../DynamicTable/NotesPopup';
import EventsPopup from '../DynamicTable/EventsPopup';
import {
    convertToPercent, dateFormat, deepCopy, dateDiff, keyToLabel, isDateInRange, yearDiff, getDemandImpactColor
} from "../../app/util";
import './groupIQ.css';
import { useSelector } from "react-redux";
export default function AncilleryRev({ Smart, arrivalDate, departureDate, collectTabData, tabData, footerData }) {
    const { app } = useSelector((state) => state);
    const { app_state, ui_state } = app.current_state;
    const { currency_symbol } = ui_state;
    const { notes, avgImpactData, eventList } = app_state;

    const [visible, setVisible] = useState([]);
    const [removableVisible, setRemovableVisible] = useState([]);
    const columnGroupObjs = useRef([]);
    const columnObjs = useRef([]);

    const [gridHeight, setGridHeight] = useState(null);

    const gridRef = useRef(null);
    const dateValueRef = useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [profitMargins, setProfitMargins] = useState({ food_beverage: 0, facilities: 0, audio_visual: 0, others: 0 })

    const columnGroup = useRef({
        date: ['staydates'], //Do not change
        total: ['total'], //Do not change
        nonRemovable: ['food_beverage', 'facilities', 'audio_visual', 'others'], // Set in useeffect1 only after that do not change
        removable: [], // Set in useeffect1 only after that do not change
        all: [], // Set in useeffect1 only after that do not change
    });

    const columnRepo = {
        staydates: [
            {
                label: 'Date',
                dataField: 'date',
                columnGroup: 'staydates',
                allowEdit: false,
                allowResize: false,
                freeze: 'near',
                width: 90,
                labelTemplate: '<div id="date-dow">Date</div>',
                template: dateColTemplate(dateFormat, notes),
            },
            {
                label: 'DOW',
                dataField: 'dow',
                columnGroup: 'staydates',
                allowEdit: false,
                allowResize: false,
                freeze: 'near',
                width: 90,
                labelTemplate: '<div id="date-dow">DOW</div>',
                template: dowColTemplate(dateFormat, avgImpactData, getDemandImpactColor, eventList, isDateInRange),
            }
        ],
        total: [{
            label: 'Total',
            labelTemplate: '<div id="secondary-header">Total</div>',
            dataField: 'total',
            columnGroup: 'total',
            freeze: 'far',
            width: 200,
            allowEdit: false,
            template: viewCurrencyTemplate(currency_symbol, formatCurrency),
        }],
        common: [
            {
                dataField: '',
                columnGroup: '',
                labelTemplate: '<div id="secondary-header"></div>',
                minWidth: 120,
                template: copyCurrencyTemplate(currency_symbol, formatCurrency, 'cell-right-border'),
            },
        ]
    }
    const getRemovableColumnGroup = (app_state, arrivalDate) => {

        let profitMarginsKey = Object.keys(footerData);
        let removableColumnGroup = profitMarginsKey.filter(item => !columnGroup.current.nonRemovable.includes(item));
        return removableColumnGroup;

    }

    const getGroupOfColumns = (columnRepo, columnGroupName, dataFieldName) => {
        let commonArr = []
        if (columnRepo[columnGroupName] === undefined) {
            let commonObj = {};
            commonObj = deepCopy(...columnRepo['common']);
            commonObj.dataField = dataFieldName;
            commonObj.columnGroup = columnGroupName;
            commonArr.push(commonObj);
        } else {
            commonArr = deepCopy(columnRepo[columnGroupName]);

        }
        return commonArr
    }

    const getColumnObjs = (columnRepo, columnGroup) => {
        let column = []
        columnGroup.current.all.map((item, index) => {
            column = [...column, ...getGroupOfColumns(columnRepo, item, item)]
        })
        return column;
    }

    useEffect(() => {
        columnGroup.current.removable = getRemovableColumnGroup(app_state, arrivalDate);
        columnGroup.current.all = [...columnGroup.current.date, ...columnGroup.current.nonRemovable, ...columnGroup.current.removable, ...columnGroup.current.total];

        if (tabData.current.dataSource.length === 0) {
            setProfitMargins(footerData)
            setVisible([...columnGroup.current.all]);
            setRemovableVisible([...columnGroup.current.removable]);

            //columnGroupObjs.current= columnGroup.current.all.map(i => ( i === 'staydates' ? {label:moment(arrivalDate).format('yyyy'), name:i, labelTemplate: `<div id="primary-header">${moment(arrivalDate).format('yyyy')}</div>`  } : {label:keyToLabel(i), name:i}));
            columnGroupObjs.current = columnGroup.current.all.map(i => (i === 'staydates' ? { label: yearDiff(arrivalDate, departureDate), name: i, labelTemplate: `<div id="primary-header">${yearDiff(arrivalDate, departureDate)}</div>` } : { label: keyToLabel(i), name: i }));
            columnObjs.current = getColumnObjs(columnRepo, columnGroup);

            gridRef.current.dataSource = new Smart.DataAdapter(setupData(arrivalDate, departureDate));

        }
        else {

            setProfitMargins(tabData.current.footerField)

            let visibleItem = tabData.current.columnGroupObjs.map(item => item.name);
            let removableVisibleItem = columnGroup.current.removable.filter(item => visibleItem.includes(item));
            setVisible(visibleItem);
            setRemovableVisible(removableVisibleItem)
            columnGroupObjs.current = [...tabData.current.columnGroupObjs]
            columnObjs.current = [...tabData.current.columnObjs]

            gridRef.current.dataSource = tabData.current.dataSource;

        }


    }, [arrivalDate, departureDate]);

    const setupDataFieldObj = (columnObjsItem) => {
        let item = columnObjsItem;
        let dataFieldObj = {};
        dataFieldObj['name'] = item.dataField;
        dataFieldObj['map'] = `${item.columnGroup}.${item.dataField}`;
        dataFieldObj['dataType'] = 'string';
        return dataFieldObj;
    }

    const setupData = (arrivalDate, departureDate) => {
        let date = moment(arrivalDate).format("YYYY-MM-DD");
        let numDays = dateDiff(departureDate, arrivalDate);
        numDays = numDays + 1;
        let dataAdapterObjet = {};
        let dataSourceArr = [];
        let dataFieldsArr = [];

        columnObjs.current.forEach(item => {
            dataFieldsArr.push(setupDataFieldObj(item));
        })

        for (let index = 0; index < numDays; index++) {
            const dataSourceObj = {};
            columnObjs.current.forEach(item => {
                if (item.columnGroup === "staydates") {
                    dataSourceObj[item.dataField] = date;
                } else {
                    dataSourceObj[item.dataField] = 0;
                }

            })
            dataSourceArr.push(dataSourceObj);
            date = moment(date).add(1, 'days').format("YYYY-MM-DD");
        }
        return dataAdapterObjet = {
            dataSource: [...dataSourceArr],
            dataFields: [...dataFieldsArr],
        }
    }


    const handleCopy = (event) => {

        const lastColumnIndex = event.detail.cell.grid.columns.length - 1;
        const lastRowIndex = event.detail.cell.grid.rows.length - 1;
        const columnId = event.detail.column.dataField;
        const rowIndex = event.detail.row.id;
        const lastColumnId = event.detail.cell.grid.viewColumns[lastColumnIndex].dataField;
        const value = event.detail.cell.value;
        let columnTotal = 0;
        let grandTotal = 0;

        let gridDataSource = deepCopy(gridRef.current.dataSource);
        for (let i = 0; i < lastRowIndex; i++) {
            let oldCellValue = Number(gridDataSource[i][columnId]);
            let oldRowTotal = Number(gridDataSource[i][lastColumnId]);
            let newRowTotal = oldRowTotal;

            if (i > rowIndex) {
                gridDataSource[i][columnId] = Number(value);

                newRowTotal = newRowTotal - oldCellValue;
                newRowTotal = newRowTotal + Number(value);
                gridDataSource[i][lastColumnId] = newRowTotal;
            }
            columnTotal += Number(gridDataSource[i][columnId]);
            grandTotal += Number(gridDataSource[i][lastColumnId]);

        }
        gridDataSource[lastRowIndex][columnId] = columnTotal;
        gridDataSource[lastRowIndex][lastColumnId] = grandTotal;
        gridRef.current.dataSource = deepCopy(gridDataSource);
        gridDataSource = [];
    };

    const editing = {
        enabled: true,
        mode: 'cell',
    };
    const selection = {
        enabled: true,
        allowCellSelection: true,
        mode: 'one',
    };
    const behavior = {
        columnResizeMode: 'growAndShrink'
    };
    const appearance = {
        alternationCount: 2,
        showColumnHeaderLines: false,
        showColumnLines: false,
        showRowLines: false,
    };
    const onRowInit = (index, row) => {
        if (index === gridRef.current.dataSource.length - 1) {
            row.freeze = 'far';
        }
    }

    const updateProfitMargins = (e, key) => {
        setProfitMargins(prev => {
            prev[key] = convertToPercent(e.target.value, 'int');
            return { ...prev };
        })
        callCollectTabData();
    }

    const callCollectTabData = () => {
        collectTabData({ dataSource: gridRef.current.dataSource, columnObjs: columnObjs.current, columnGroupObjs: columnGroupObjs.current, footerField: profitMargins });
    }
    const onCellUpdate = (cells, oldValues, values, confirm) => {

        const lastColumnIndex = cells[0].grid.columns.length - 1;
        const lastRowIndex = cells[0].grid.rows.length - 1;
        const columnId = cells[0].column.dataField;
        const rowIndex = cells[0].row.id;
        const lastColumnId = cells[0].grid.viewColumns[lastColumnIndex].dataField;
        const oldCellValue = isNaN(oldValues[0]) ? 0 : parseInt(oldValues[0]);
        const newValue = isNaN(values[0]) ? 0 : parseInt(values[0]);

        if (rowIndex === lastRowIndex ||
            newValue < 0
        ) {
            confirm(false);
        }
        else {
            let gridDataSource = gridRef.current.dataSource;

            //Column Total
            let totalCellValue = parseInt(gridDataSource[lastRowIndex][columnId]);
            totalCellValue = totalCellValue - oldCellValue;
            let finalTotalValue = totalCellValue + newValue;
            gridDataSource[lastRowIndex][columnId] = finalTotalValue;

            //Row Total
            let rowTotalCellValue = parseInt(gridDataSource[rowIndex][lastColumnId]);
            rowTotalCellValue = rowTotalCellValue - oldCellValue;
            let rowFinalTotalValue = rowTotalCellValue + newValue;
            gridDataSource[rowIndex][lastColumnId] = rowFinalTotalValue;

            //Grand Total
            let grandTotalCellValue = parseInt(gridDataSource[lastRowIndex][lastColumnId]);
            grandTotalCellValue = grandTotalCellValue - oldCellValue;
            let grandFinalTotalValue = grandTotalCellValue + newValue;
            gridDataSource[lastRowIndex][lastColumnId] = grandFinalTotalValue;

            gridRef.current.dataSource = gridDataSource;
            gridDataSource = [];
            confirm(true);
            callCollectTabData();

        }
    }

    let clickElementEvent;
    const onBeginEdit = (event) => {
        const { id, value, dataField } = event.detail
        if (clickElementEvent.detail.originalEvent.target.classList.contains('note-icon-span')) {
            handleClick(clickElementEvent.detail.originalEvent, event.detail.data.date);
        }

        if (clickElementEvent.detail.originalEvent.target.classList.contains('event-icon-span')) {
            handleClick(clickElementEvent.detail.originalEvent, event.detail.data.date);
        }

        if (clickElementEvent.detail.originalEvent.target.classList.contains('copy-btn')) {
            handleCopy(event);
            event.preventDefault();
        }
        if ((gridRef.current.dataSource.length - 1) === event.detail.row.id) {
            event.preventDefault();
        }

    }
    const onCellClick = (event) => {
        clickElementEvent = event;
    }

    const handleClick = (event, dateValue) => {
        dateValueRef.current = dateValue;
        setAnchorEl(event);

        if (event.target.className === 'note-icon-span') {
            let noteIconDiv = document.getElementsByClassName('note-icon-div');
            noteIconDiv[0].click();
        }

        if (event.target.className === 'event-icon-span') {
            let noteIconDiv = document.getElementsByClassName('event-icon-div');
            noteIconDiv[0].click();
        }

    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'outerPopupCover' : undefined;

    const setTableHeight = () => {
        let windowHeight = window.innerHeight;
        setGridHeight(windowHeight - 350);
    };

    useEffect(() => {
        setTableHeight();
        window.addEventListener("resize", setTableHeight);

        return () => {
            window.removeEventListener("resize", setTableHeight);
        };
    }, [arrivalDate, departureDate]);

    return (
        <div>
            <div className='tab-content-root ancillary-tab'
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    //height:'auto',
                    height: `${gridHeight}px`,
                    overflow: 'hidden',
                }}
            >
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    anchorReference="anchorPosition"
                    anchorPosition={anchorEl && { top: anchorEl.clientY, left: anchorEl.clientX }}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    className='outer-popup-cover'
                    style={{ opacity: 0, visibility: 'hidden' }}
                >

                    {anchorEl && anchorEl.target.className === 'note-icon-span' && <NotesPopup params={{ stay_date: dateValueRef.current, readonly: true }} outerHandleClose={handleClose} />}
                    {anchorEl && anchorEl.target.className === 'event-icon-span' && <EventsPopup params={{ stay_date: dateValueRef.current }} outerHandleClose={handleClose} />}
                </Popover>
                <Grid
                    style={{ flexGrow: 1 }}
                    id="mygrid"
                    columns={columnObjs.current}
                    columnGroups={columnGroupObjs.current}
                    ref={gridRef}
                    editing={editing}
                    behavior={behavior}
                    appearance={appearance}
                    onRowInit={onRowInit}
                    selection={selection}
                    onCellUpdate={onCellUpdate}
                    onBeginEdit={onBeginEdit}
                    className='ancillery-rev-grid'
                    onCellClick={onCellClick}
                ></Grid>
                <div className="room-block-bottom">
                    <div className="left-bottom-data">
                        <strong>Profile Margin:</strong>
                        {columnObjs.current.map((item) => {
                            return (
                                <>
                                    {['staydates', 'total'].includes(item.columnGroup) ? null
                                        :
                                        <label for={item.dataField} key={item.dataField} >{keyToLabel(item.dataField)}: <span className="value-box"><input id={item.dataField} type="number" defaultValue={convertToPercent(profitMargins[item.dataField])} onBlur={(e) => { updateProfitMargins(e, item.dataField) }} />%</span></label>
                                    }
                                </>
                            )
                        })}
                    </div>
                    <div></div>
                </div>
            </div>
        </div>
    )
}
